import { getEnvRequired } from '../../shared/utilities/env';
import { ApiClient } from '../shared/api/client';

import { serializeAgentFromAPI } from './serializers';
import { AgentJSONAPIResponse } from './types';

const REQUEST_MANAGER_API_URL = getEnvRequired('REQUEST_MANAGER_API_URL');

const apiClient = new ApiClient(true);

export async function fetchAgents() {
    const url = `${REQUEST_MANAGER_API_URL}/agency/agent`;

    const response = await apiClient.get<AgentJSONAPIResponse>(url);

    return serializeAgentFromAPI(response);
}
